import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { widgetsReducer } from './reducers/widgets.reducer';
import { WIDGETS_FEATURE_KEY } from './widgets.state';

/**
 * Registers the widgets store slice. Imported by `WidgetsModule`, which is the
 * only consumer — the slice exists purely to evaluate the signal-forms/NgRx
 * wiring on the widget test screen.
 *
 * Unlike the address and timesheet slices there are no effects and no
 * registration with the generic persistence layer: the demo values are not worth
 * persisting, and leaving persistence out keeps the write path down to
 * "dispatch → reducer" so the round trip is easy to follow in the devtools.
 */
@NgModule({
    imports: [StoreModule.forFeature(WIDGETS_FEATURE_KEY, widgetsReducer)],
})
export class WidgetsStoreModule {}
